import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { signupRequest } from '@/api';
import { SignupTenant, MultiStepSignup } from '@/components/shared/SignUp';
import type { IMultiStepSignupValues } from '@/components/shared/SignUp/MultiStepSignup';
import getAxiosErrors from '@/utils/getAxiosErrors';
import { useToast } from '@/components/shared/ToastProvider';
import './SignupPage.scss';
import { SignupDto } from '@/types';

const SignupPage = () => {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('inviteToken');
  const { showSuccess, showError } = useToast();

  const [isSubmitting, setIsSubmitting] = useState(false);

  // If there's an inviteToken - this is tenant registration
  if (inviteToken) {
    return <SignupTenant />;
  }

  // Multi-step form handler
  const handleMultiStepSubmit = async (values: IMultiStepSignupValues) => {
    setIsSubmitting(true);

    try {
      const signupData: SignupDto = {
        role: values.role,
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        password: values.password,
        // Manager fields
        ...(values.role === 'manager' && {
          companyName: values.companyName,
          department: values.department,
          jobTitle: values.jobTitle,
        }),
        // Additional fields
        province: values.province,
        phone: values.phone,
        ageGroup: values.ageGroup,
        // Tenant invite token (if any)
        inviteToken: inviteToken,
      };

      await signupRequest(signupData);

      // On successful registration, we no longer log the user in.
      // The user will stay on the confirmation step.
      showSuccess('Registration successful! Please check your email to confirm your account.');

    } catch (err: any) {
      console.error('Signup error:', err);

      const errorData = getAxiosErrors(err);
      const message = errorData.message || err.response?.data?.message || 'Registration failed. Please try again.';
      showError(message);
      throw err; // <-- Добавлена эта строка для переброса ошибки
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MultiStepSignup
      onSubmit={handleMultiStepSubmit}
      isSubmitting={isSubmitting}
    />
  );
};

export default SignupPage;
